<template>
  <div id="v3RebateRoot">
    <div v-if="!isShowGrabRebateLog" id="v3Rebate">
      <div v-if="needTimeCountOnTop" id="v3RebateTopDiv">
        <img id="v3RebateTopTopBg" src="~assets/img/SdkV3/RebateTopTopBg.png">
        <div id="v3RebateTopContentDiv" v-if="typeType == '1' || typeType == '2'">
          <div id="v3RebateTopRoleInfoDiv">
            <img id="v3RebateAvatar" src="~assets/img/SdkV3/RebateTopAvatar.png" style="object-fit: scale-down;" />
            <div id="v3RebateRoleDiv">
              <!-- <img src="~assets/img/SdkV3/MineTopBg.png" style="width: 100%;height: 100%;z-index: 1199;"> -->
              <span style="color:white;font-size: small;font-weight: bold;">{{ $store.state.roleInfoData.roleName }}</span>
              <div>
                <span style="color:#FCDA82;font-size: x-small;">{{ $store.state.roleInfoData.level }}级</span>
                <span
                  style="color:#FCDA82;font-size: x-small;margin-left: 5px;">{{ $store.state.roleInfoData.serverName }}</span>
              </div>
            </div>
            <span id="v3RebateCopy" @click="onCopyClick()">复制</span>
          </div>
          <div id="v3RebateBonusDiv">
            <span style="color:white;font-size:smaller;font-weight:bold;margin-right: 3px;">奖金</span>
            <span style="color:white;font-size:large;font-weight:bold;">{{ $store.state.initData.bonusPool }}</span>
            <span style="color:white;font-size:smaller;font-weight:bold;margin-left: 3px;">元</span>
          </div> 
          <div id="v3RebateTimerDiv">
            <span style="color:white;font-size:x-small;margin-right: 5px;">仅剩</span>
            <div style="color:#FCDA82;font-size:x-small;">{{ count }}</div>
          </div>
          <div id="tTLoginTimeDiv">
            <span style="color:white;font-size:x-small;;margin-right: 5px;">已累计登录</span>
            <div style="color:#FCDA82;font-size:x-small;">{{ $store.state.userInfoData.daycount }}</div>
            <span style="color:white;font-size:x-small;;margin-left: 5px;">天，</span>
            <span style="color:white;font-size:x-small;;margin-right: 5px;">连续登录</span>
            <div style="color:#FCDA82;font-size:x-small;">{{ $store.state.userInfoData.dayconsecutive }}</div>
            <span style="color:white;font-size:x-small;;margin-left: 5px;">天</span>
          </div>
        </div>
        <div v-if="typeType == '6'" style="color: white;display: flex;justify-content: center;align-items: center;flex-direction: row;  margin-top: 3px;position: absolute;top: 2%;right: 2%;font-size: xx-small;font-weight: bold;text-decoration: underline;" @click="clickGrabShowRule()">
          抢红包次数剩余无限次<div style="margin-left: 2px;margin-top: 2px;width:14px;height:14px;background:white;border-radius: 10px;display: flex;justify-content: center;align-items: center;color:#F81D01;font-size: xx-small;">?</div>
        </div>
        <span v-else id="v3RebateRule" @click="onRuleClick()">活动规则</span>
      </div>
      <div id="v3RebateContent">
        <div v-if="showActivityBanner"
          style="width:100%;height: 16vw;display: flex;align-items: center;justify-content: center;margin-bottom: 5px;">
          <img
            style="width:80vw;height: 100%;margin-top: 10px;border-radius: 10px;border-style: solid; border-width: 1px; border-color: #EFEFEF;"
            src="~assets/img/SdkV3/activityBanner.png" />
        </div>
        
        <div id="v3RebateListDiv" :style="{ height: (needTimeCountOnTop ? showActivityBanner ? '50vh' : '57vh' : '70vh') }">
          
        <!-- 抢红包页面的上面展示内容部分 -->
        <!-- <div v-show="typeType == '6'" style="background: -webkit-linear-gradient(left, #FC6629, #F81D01);width:85vw;height: 5vh;color: #F8CF82;display: flex;justify-content: center;align-items: center;flex-direction: row;" @click="clickGrabShowRule()">
          抢红包次数剩余无限次<div style="margin-left: 2px;margin-top: 2px;width:14px;height:14px;background:#F7EC9C;border-radius: 10px;display: flex;justify-content: center;align-items: center;color:#F81D01;font-size: xx-small;">?</div>
        </div> -->
          <!-- :key 一定要是唯一的，如果配置为index，可能会在替换这个for循环的时候，因为index一样而导致部分子项无法更新对应数据 -->
          <!-- 因为 rebateList 可能会变化，所以要唯一，但是在 数组不会变化的时候，:key则可以使用index -->
          <div v-for="(item, index) in rebateList" :key="item.confid + item.desc" :index="index + ''">
            <RebateItem :rebateItem="item"></RebateItem>
          </div>
        </div>
      </div>
      <Rule v-show="showRule" @hiderulepage="hiderulepage" />
      <V3PasswordRebateDialog v-show="showPasswordRebate"/>
    </div>
    <V3GrabRebateLog v-show="isShowGrabRebateLog" :rebateName="rebateName" :surplus="surplus" :listData="listData"></V3GrabRebateLog>
  </div>
</template>

<script>
import RebateTypes from './RebateTypes.vue';
import RebateItem from './RebateItem.vue';
import V3PasswordRebateDialog from './V3PasswordRebateDialog.vue';
import V3GrabRebateLog from './V3GrabRebateLog.vue';

import Rule from '../rule/Rule.vue';
import { request } from '@/SdkV3/network/request';
import getRequestParams from "@/signParams";

export default {
  props: {
    needTimeCountOnTop: false,//是否需要展示上面的倒计时等用户信息
    typeId: "",//红包类型id，用于获取红包列表数据
    showActivityBanner: false,//是否展示活动banner
    typeType: "", // 当前选择的红包的类型名字
  },
  data() {
    return {
      count: '', //倒计时
      seconds: this.$store.state.userInfoData.timeout, // 10天的秒数
      // typeId: this.$store.state.initData.rebateType[0]['typeid'], // 选中的红包类型的id，用来获取红包数据
      rebateList: [], // 根据红包类型id获取的红包数组
      showRule: false, // 是否显示规则
      showPasswordRebate: false,
      itemRebate: null,
      isShowGrabRebateLog: false, //展示抢红包列表
      rebateName: "",
      surplus: "0", // 是否还有红包剩余未抢（0：否，1：是）
      listData: [],
      times: "0",//抢红包剩余次数
      grabRuleContent: "", //抢红包规则
      ruleContent: "",
    }
  },
  components: {
    RebateTypes, RebateItem, Rule, V3PasswordRebateDialog, V3GrabRebateLog
  },
  watch: {
    needTimeCountOnTop: {
      handler(newValue, oldValue) {
        if (newValue && this.count.length < 1) {
          this.Time(); //调用定时器
        }
      }
    },
    typeId: {
      handler(newValue, oldValue) {
        if (newValue != "-1") {
          this.fetchRebateList();// 获取红包数据
          this.showRule = false;
        }
      }
    }
  },
  created() {
    if (this.needTimeCountOnTop) {
      this.Time(); //调用定时器
    }
    this.fetchRebateList();// 获取红包数据
  },
  methods: {
    clickGrabShowRule(){
      this.$store.commit("updateAlertMessageSize", "x-small")
      this.$store.commit('switchAlert', {"showOrHide": true, "alertMessage": this.grabRuleContent})
    },
    hiderulepage() {
      this.showRule = false;
    },
    fetchRebateList() {
      let storeCommomParams = this.$store.state.commonParameters;
      storeCommomParams['typeid'] = this.typeId
      // console.log("获取红包列表数据,", storeCommomParams);
      // console.log("this.typeId :", this.typeId);
      let rebateReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_SHOW,
        params: {
          data: rebateReqParams
        },
      }).then(res => {
        let listData = JSON.parse(res.rebateList);
        // 将对应选择的红包类型的名称，传到每一项item中，用于特殊显示领取按钮
        listData.forEach(element => {
          element['typeType'] = this.typeType
        });
        this.rebateList = listData
        this.ruleContent = res.content
        // this.rebateList.forEach(element => {
        //   element['timeout'] = '' + Math.floor(Math.random() * (87410 - 82520) + 82520)
        //   element['limit'] = '' + Math.floor(Math.random() * (4 - 1) + 1)
        //   // element['status'] = '3'
        //   // element['limit'] = '1'
        // });
        // console.log("红包数据", this.rebateList);
      });

      if (this.typeType == '6') {
        // 获取剩余抢红包次数
        request({
          url: this.urls.REBATE_GRABREBATEUSER,
          params: {
            data: rebateReqParams
          },
        }).then(res => {
          this.times = res.times
          this.grabRuleContent = res.content
        });
      }
      
    },
    // 天 时 分 秒 格式化函数
    countDown() {
      let d = parseInt(this.seconds / (24 * 60 * 60))
      d = d < 10 ? "0" + d : d
      let h = parseInt(this.seconds / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(this.seconds / 60 % 60);
      m = m < 10 ? "0" + m : m
      let s = parseInt(this.seconds % 60);
      s = s < 10 ? "0" + s : s
      this.count = d + '天 ' + h + ':' + m + ':' + s + ''
    },
    //定时器没过1秒参数减1
    Time() {
      setInterval(() => {
        this.seconds -= 1
        this.countDown()
      }, 1000)
    },
    hidePasswordRebateDialog(){
      this.showPasswordRebate = false

    },
    ensurePasswordRebate(passCode){
      this.receiveRebate(this.itemRebate, passCode ,(res)=>{ 
        console.log("ensurePasswordRebate成功后的动作") 
        
        this.$store.commit("updateAlertMessageSize", "small")
        this.$store.commit('switchAlert', {"showOrHide": true, "alertMessage": "恭喜你，领取到了"+res.money+"元红包！"})
      })
    },
    // 领取红包
    rebateReceive(item) {
      // console.log("领取红包");
      if (item['word'] == '1') {
        // 有口令，需要展示输入口令的界面
        this.itemRebate = item
        this.showPasswordRebate = true
        return
      }
      this.receiveRebate(item, "", (res)=>{ console.log("rebateReceive成功后的动作") })
    },
    // 抢红包
    grabRebate(item) {
      console.log("抢红包", item);
      
      this.receiveRebate(item, "", 
      (res)=>{
        console.log("抢红包成功后的动作");
        // 展示抢红包的列表
        this.showGrabRebateLog(item)
      })
    },
    showGrabRebateLog(item){

      if (this.times == '0') {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "抢红包剩余次数不足" });
        return
      }

      this.rebateName = item.name
      let storeCommomParams = this.$store.state.commonParameters;
      storeCommomParams['confid'] = item['confid']
      // console.log("获取抢红包列表数据,", storeCommomParams);
      // console.log("item:", item);
      let rebateReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_GRABLOG,
        params: {
          data: rebateReqParams
        },
      }).then(res => {
        // console.log("抢红包返回数据：", res);
        this.surplus = res.surplus
        this.listData = JSON.parse(res.grabRebateLog);
        // console.log("抢红包列表数据", this.listData);
        this.isShowGrabRebateLog = true

      });
    },
    hideGrabRebatePage(){
      this.isShowGrabRebateLog = false
    },
    receiveRebate(item, passCode, rebackFunc){
      let storeCommomParams = this.$store.state.commonParameters
      let configData = { "confid": item["confid"] }
      if (passCode && passCode.length > 0) {
        configData['word'] = passCode
      }
      let levelRebateReceiveReqParams = getRequestParams(configData, storeCommomParams);
      request({
        url: this.urls.REBATE_RECEIVE,
        params: {
          data: levelRebateReceiveReqParams
        },
      }).then(res => {
        // console.log(res);
        // store/index.js 中的 actions 接收处理方法
        this.$store.dispatch("networkRebateRecevice", res);
        // 领取成功，重新请求数据
        this.fetchRebateList();
        // 关闭口令兑换弹窗
        if (this.showPasswordRebate) {
          this.hidePasswordRebateDialog()
        }
        rebackFunc(res)
      }).catch(error => {
        let errorMessage = error["message"];
        // console.log(error["message"]);
        // 该账号未绑定提取方式
        if ("该账号未绑定提取方式" === errorMessage) {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "该账号未绑定提取方式" });
          // console.log("点击绑定微信");
          let storeCommomParams = this.$store.state.commonParameters
          // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
          let wxBindReqParams = getRequestParams({}, storeCommomParams);
          request({
            url: this.urls.REBATE_WXAUTH,
            params: {
              data: wxBindReqParams
            },
          }).then(res => {
            if ("qrcode" == res.type) {
              let qrcodeUrl = JSON.parse(res.param)['url'];
              this.$store.dispatch('networkWxBindPageShow', { "showOrHide": true, "qrcodeUrl": qrcodeUrl })
            } else {
              this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "暂无绑定方式" })
              this.$store.dispatch('networkWxBindPageShow', { "showOrHide": false, "qrcodeUrl": "" })
            }
          })
        }
        if (errorMessage.includes('2017')) {
          rebackFunc()
        }
      })
    },
    rebateitemclick(typeid) {
      if (this.typeId !== typeid) {
        this.typeId = typeid;
        // console.log(typeid);
        this.fetchRebateList();// 获取红包数据
      }
    },
    onRuleClick() {
      console.log("规则内容", this.ruleContent);
      this.$store.commit("updateRuleContent", this.ruleContent)
      this.showRule = true;
    },
    onCopyClick() {
      var obj = { "content": this.$store.state.commonParameters["rid"], "toastMsg": "用户id复制成功" };
      this.sendToClient('copyClick?' + JSON.stringify(obj))
    },
  },
  computed: {
    // 计算属性要传参的话，就是用函数返回
    // 红包子项倒计时处理
    // getTimeCountdown(){
    //   return rebateItem =>{
    //   }
    // }
  }
}
</script>

<style>
#v3RebateRoot {
  position: relative;
  height: 70vh;
}

#v3Rebate {
  height: 100%;
  width: 100%;
  /* position: relative; */
}

#v3RebateTopDiv {
  position: relative;
  height: 100px;
  /* width: 100%; */
  /* align-items: Center;  */
  /* font-size: 0; */
  display: flex;
  flex-direction: row;
}

#v3RebateTopTopBg {
  /* object-fit: fill; */
  /* background-color: #F84524; */
  height: 100px;
  width: 100%;
  /* position:absolute; */
  display: block;
}

#v3RebateTopContentDiv {
  /* background-color: violet; */
  height: 100px;
  /* width:100%; */
  display: block;
  /* height: 100%; */
  position: absolute;
  object-fit: scale-down;
  padding-left: 20px;
  /* padding-top: 10px; */
  display: flex;
  flex-direction: column;
}

#v3RebateTopRoleInfoDiv {
  padding-top: 5px;
  object-fit: scale-down;
  display: flex;
  flex-direction: row;
}

#v3RebateAvatar {
  width: 35px;
  height: 35px;
  /* margin-top: 30px; */
}

#v3RebateRoleDiv {
  padding-left: 5px;
  /* background-color: yellow; */
  /* height: 35px; */
  /* padding-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
}

#v3RebateCopy {
  display: block;
  color: white;
  font-size: xx-small;
  font-weight: bold;
  height: 15px;
  line-height: 15px;
  /* text-align: center; */
  padding-left: 3px;
  padding-right: 3px;
  border: 1px solid white;
  border-radius: 4px 4px 4px 4px;
  /* margin-top: 2px; */
  transform: scale(0.7);
}

#v3RebateRule {
  margin-top: 3px;
  position: absolute;
  top: 2%;
  right: 2%;
  float: right;
  color: white;
  font-size: xx-small;
  font-weight: bold;
  /* transform: scale(0.8); */
  text-decoration: underline;
}

#v3RebateBonusDiv {
  /* background-color: aqua; */
  margin-top: 2px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

#v3RebateTimerDiv {
  /* background-color: aqua; */
  /* margin-top: 2px; */
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

#tTLoginTimeDiv {
  /* background-color: aqua; */
  /* margin-top: 2px; */
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

#v3RebateContent {
  background-color: #F6F6F6;
  display: flex;
  flex-direction: column;
}

#v3RebateTypeDiv {
  height: 40px;
  /* background-color: yellowgreen; */
}

#v3RebateListDiv {
  /* height: calc(70vh - 100px - 45px); */
  /* height: 32vh; */
  /* background-color: rebeccapurple; */
  overflow-y: auto;
  /* 下面的操作都是为了隐藏滑条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
}

#v3RebateListDiv::-webkit-scrollbar {
  display: none;
}</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rebate/V3Rebate.vue